import { render, staticRenderFns } from "./manageBookingsIMBP.vue?vue&type=template&id=f389de92&scoped=true"
import script from "./manageBookingsIMBP.vue?vue&type=script&lang=js"
export * from "./manageBookingsIMBP.vue?vue&type=script&lang=js"
import style0 from "./manageBookingsIMBP.vue?vue&type=style&index=0&id=f389de92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f389de92",
  null
  
)

export default component.exports